/* global $ */
'use strict';

function modals(EVENTS) {
	var PubSub = require('pubsub-js');

	var MODAL_CLASS = 'modal-box';
	var MODAL_SHOW_CLASS = 'is-active';
	var MODAL_BODY_CLASS = 'modal-active';

	PubSub.subscribe(EVENTS.MODAL_OPEN, modalOpen);
	PubSub.subscribe(EVENTS.MODAL_CLOSE, modalClose);

	function modalOpen (msg, id) {
		$(id).addClass(MODAL_SHOW_CLASS);
		$('html').addClass(MODAL_BODY_CLASS);
	}

	function modalClose () {
		$('.' + MODAL_CLASS).removeClass(MODAL_SHOW_CLASS);
	}

	function bindEvents () {
		$('body').on('click', 'a[data-dismiss="modal"]', function (e) {
			e.preventDefault();
			modalClose();
			PubSub.publish(EVENTS.MODAL_CLOSE_TRACKING);
			$('html').removeClass(MODAL_BODY_CLASS);
		});
	}

	bindEvents();

}

module.exports = modals;
